import ACTIONS from "../../constatnts"

export const activeelement = (state = null, actions) => {
  const {type, payload} = actions

  switch (type) {
    case ACTIONS.SET_ACTIVE_ELEMENT:
      return payload
    default:
      return state
  }
}
